import { mapKeys } from "radash"
import { getBreakpointPixelValue } from "../Media"
import type { CarouselOptions, EmblaOptionsType, Breakpoints } from "./types"

export function getCarouselOptions(options: CarouselOptions): EmblaOptionsType {
  if (options.breakpoints) {
    const { breakpoints, ...rest } = options
    const breakpointsWithPixelValues = mapKeys(
      // @ts-expect-error mapKeys doesn't play nice with Partial Records
      breakpoints,
      key => `(min-width: ${getBreakpointPixelValue(key)}px)`,
    ) as Breakpoints
    return {
      ...rest,
      breakpoints: breakpointsWithPixelValues,
    }
  }

  return options
}
